"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseDate = void 0;
const trim = (value) => value.replace(/(^\s+|\s+$)/g, '');
const parseDate = (value, hasTime = false, is12Hours = false) => {
    value = trim(value);
    const isRightPattern = /^\d{2}(\.|-|\/|\s|\\)\d{2}(\.|-|\/|\s|\\)\d{4}(\s|$)/.test(value);
    if (!isRightPattern) {
        return null;
    }
    const date = Number(value.slice(0, 2));
    const month = Number(value.slice(3, 5)) - 1;
    const year = Number(value.slice(6, 10));
    const isAnyValueIsNaN = isNaN(date) || isNaN(month) || isNaN(year);
    const isValid = !isAnyValueIsNaN && !(date < 1 || month < 0 || date > 31 || month > 11) && year >= 1900;
    if (!isValid) {
        return null;
    }
    const dateValue = new Date(year, month, date);
    if (dateValue.getDate() !== date ||
        dateValue.getMonth() !== month ||
        dateValue.getFullYear() !== year) {
        return null;
    }
    if (!hasTime) {
        return dateValue;
    }
    const parsedTime = value.match(/\s+(\d{1,2}:\d{2})($|\s(am|pm|AM|PM)$)/);
    if (!parsedTime) {
        return null;
    }
    const [hours, minutes] = parsedTime[1].split(':');
    const meridiem = trim((parsedTime[2] || '').toLowerCase());
    if (!is12Hours && meridiem) {
        return null;
    }
    if (is12Hours && !meridiem) {
        return null;
    }
    let numberHours = Number(hours);
    const numberMinutes = Number(minutes);
    if (numberHours > 24) {
        return null;
    }
    if (numberMinutes > 59 || numberMinutes < 0) {
        return null;
    }
    if (meridiem && (numberHours < 1 || numberHours > 12)) {
        return null;
    }
    if (meridiem === 'pm') {
        numberHours = numberHours + 12;
    }
    if (meridiem === 'am' && numberHours === 12) {
        numberHours = 0;
    }
    if (numberHours === 24) {
        return null;
    }
    dateValue.setHours(numberHours, numberMinutes);
    return dateValue;
};
exports.parseDate = parseDate;
//# sourceMappingURL=parseDate.js.map